module.exports = __webpack_public_path__ + "img/bac5565.jpg";